import axios from 'axios';

export default {
    methods: {
        async incidenciaIndex(d, ok, err) {
            try {
                let r = await axios.get('calidad/incidencia?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaStore(d, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia', d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async incidenciaUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('calidad/incidencia/' + id, d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async incidenciaShow(id, ok, err) {
            try {
                let r = await axios.get('calidad/incidencia/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaVincular(ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/vincular');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaSectores(ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/sectores');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaEtapas(ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/etapas');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaEtapasEstados(d, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/etapas-estados', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaOrigenes(ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/origenes');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaObsStore(d, h, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/obs', d, h);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaObsUpdate(d, ok, err) {
            try {
                let r = await axios.put('calidad/incidencia/obs/' + d.id, d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaPendientes(d, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/pendientes', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaAprobar(d, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/aprobar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaRechazar(d, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/rechazar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaCerrar(d, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/cerrar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async incidenciaAvisar(d, ok, err) {
            try {
                let r = await axios.post('calidad/incidencia/avisar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/calidad/incidencia.js